// extracted by mini-css-extract-plugin
export var grid = "tooltip-module--grid--dee67";
export var gridWithRowGap = "tooltip-module--grid--with-row-gap--ade66";
export var maxWidthContainer = "tooltip-module--max-width-container--51709";
export var mt0 = "tooltip-module--mt-0--4abc4";
export var mt1 = "tooltip-module--mt-1--f78a0";
export var mt2 = "tooltip-module--mt-2--df89e";
export var mt3 = "tooltip-module--mt-3--b279a";
export var mt4 = "tooltip-module--mt-4--34c8b";
export var mt5 = "tooltip-module--mt-5--d04c1";
export var mt6 = "tooltip-module--mt-6--49d44";
export var removeVisuallyHidden = "tooltip-module--remove-visually-hidden--2e3e7";
export var tooltip = "tooltip-module--tooltip--b52d8";
export var tooltip__content = "tooltip-module--tooltip__content--82f68";
export var tooltip__trigger = "tooltip-module--tooltip__trigger--73905";
export var tooltip__triggerButton = "tooltip-module--tooltip__trigger-button--94d75";
export var visuallyHidden = "tooltip-module--visually-hidden--a5023";
export var widgetBase = "tooltip-module--widget-base--f2490";